/**
 * Tawk.to Configuration
 * 
 * Get your property ID and widget ID from your tawk.to dashboard.
 * The script URL format is: https://embed.tawk.to/PROPERTY_ID/WIDGET_ID
 */

// Environment detection
const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

export const tawkToConfig = {
  propertyId: process.env.REACT_APP_TAWKTO_PROPERTY_ID || '',
  widgetId: process.env.REACT_APP_TAWKTO_WIDGET_ID || 'default',
  
  // Styling options (these will be applied via CSS)
  styling: {
    // Primary color for the widget (matches your app theme)
    primaryColor: '#3b82f6', // Tailwind blue-500
    
    // Position of the widget
    position: 'bottom-right' as const,
    
    // Custom CSS for theming (inject into page)
    customCSS: `
      /* Tawk.to widget custom styling */
      #tawk-bubble {
        background-color: #1f2937 !important; /* Tailwind gray-800 */
        border: 1px solid #374151 !important; /* Tailwind gray-700 */
      }
      
      #tawk-bubble .tawk-chat-bubble {
        background-color: #3b82f6 !important; /* Tailwind blue-500 */
      }
      
      /* Chat window styling */
      .tawk-chat-panel {
        border-radius: 8px !important;
        box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
      }
      
      /* Dark theme adjustments */
      .tawk-chat-header {
        background-color: #1f2937 !important;
        color: #f9fafb !important;
      }
      
      .tawk-chat-message-container {
        background-color: #111827 !important;
      }
      
      /* Development environment indicator */
      ${isDevelopment ? `
        #tawk-bubble::after {
          content: 'DEV';
          position: absolute;
          top: -8px;
          right: -8px;
          background: #f59e0b;
          color: white;
          font-size: 10px;
          padding: 2px 4px;
          border-radius: 3px;
          font-weight: bold;
        }
      ` : ''}
    `,
  },
  
  // Default user attributes to send
  defaultAttributes: {
    product: 'wrappractice',
    version: process.env.REACT_APP_VERSION || '1.0.0',
    environment: process.env.NODE_ENV || 'development',
    buildTime: process.env.REACT_APP_BUILD_TIME || new Date().toISOString(),
  },
  
  // Feature flags with environment awareness
  features: {
    // Smart enabling: only enable in production by default, or if explicitly enabled
    enabled: process.env.REACT_APP_TAWKTO_ENABLED === 'true' || 
             (isProduction && process.env.REACT_APP_TAWKTO_ENABLED !== 'false'),
    
    showOnLanding: false, // Don't show widget automatically on landing
    showInApp: true,      // Available in app via menu
    autoShow: false,      // Don't auto-show chat window
    autoPopup: false,     // Don't auto-popup on page load
    hideByDefault: true,  // Hide widget by default, show only when requested
    
    // Development-specific features
    debugMode: isDevelopment && process.env.REACT_APP_TAWKTO_DEBUG === 'true',
  },
};

// Enhanced validation with environment context
if (tawkToConfig.features.enabled && !tawkToConfig.propertyId) {
  console.warn('Tawk.to is enabled but REACT_APP_TAWKTO_PROPERTY_ID is not set');
} 